import { useDaumPostcodePopup } from "react-daum-postcode"
import CSInput from "../Input/Index"
import { Form } from "antd"
import { useEffect } from "react"

type Props = {
  label?: string
  name: string
  placeholder: string
  onCompleteAddress: (value: any) => void
  type?: "input" | "button"
  btnClassName?: string
  wrapClassName?: string
  isWebView?: boolean
}

declare global {
  interface Window {
    ReactNativeWebView?: {
      postMessage: (message: string) => void
    }
  }
}

const POSTCODE_URL = 'https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';

export const Postcode = ({
  label,
  name,
  placeholder,
  onCompleteAddress = () => {},
  type = "input",
  btnClassName,
  wrapClassName,
  isWebView = false,
}: Props) => {
  const open = useDaumPostcodePopup(POSTCODE_URL)

  useEffect(() => {
    if (isWebView) {
      const handleAddressComplete = (event: CustomEvent<any>) => {
        console.log('선택된 주소:', event.detail);
        handleComplete(event.detail);
      }

      const handleMessage = (event: MessageEvent) => {
        console.log('메시지 이벤트 수신:', event.data);
        try {
          const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
          if (data.type === 'ADDRESS_SELECTED') {
            handleComplete(data.address);
          }
        } catch (error) {
          console.error('메시지 처리 중 오류:', error);
        }
      }

      document.addEventListener('addressComplete', handleAddressComplete as EventListener);
      window.addEventListener('message', handleMessage);
      
      return () => {
        document.removeEventListener('addressComplete', handleAddressComplete as EventListener);
        window.removeEventListener('message', handleMessage);
      }
    }
  }, [isWebView])

  const handleComplete = (data: any) => {
    console.log('주소 처리 시작:', data);
    let fullAddress = data.address
    let extraAddress = ""

    if (data.addressType === "R") {
      if (data.bname !== "") {
        extraAddress += data.bname
      }
      if (data.buildingName !== "") {
        extraAddress +=
          extraAddress !== "" ? `, ${data.buildingName}` : data.buildingName
      }
      fullAddress += extraAddress !== "" ? ` (${extraAddress})` : ""
    }
    console.log('처리된 주소:', fullAddress);
    onCompleteAddress(data)
    return fullAddress
  }

  const handleClick = () => {
    console.log('주소 검색 버튼 클릭, isWebView:', isWebView);
    if (isWebView) {
      const message = JSON.stringify({ 
        type: 'OPEN_POSTCODE',
        url: POSTCODE_URL
      });
      console.log('전송할 메시지:', message);
      
      // 웹뷰와 일반 웹 환경 모두 지원
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(message);
      } else {
        window.postMessage(message, '*');
      }
    } else {
      open({ onComplete: handleComplete })
    }
  }

  if (type === "button") {
    return (
      <Form.Item name={name} className={wrapClassName}>
        <button className={btnClassName} onClick={handleClick} type="button">
          {label}
        </button>
      </Form.Item>
    )
  }

  return (
    <CSInput
      label={label}
      name={name}
      placeholder={placeholder}
      onClick={handleClick}
    ></CSInput>
  )
}
